import { createSlice } from "@reduxjs/toolkit";
import {
  validateSnRange,
  moveSnToCompany,
  getBranchList,
} from "../action/management-sn.action";

const MANAGEMENT_SN = "managementSn";

const initialState = {
  branches: [],
  validateResult: null,
  isValidating: false,
  isMoving: false,
  moveResult: null,
};

const managementSnSlice = createSlice({
  name: MANAGEMENT_SN,
  initialState,
  reducers: {
    clearValidateResult: (state) => {
      state.validateResult = null;
    },
    clearMoveResult: (state) => {
      state.moveResult = null;
    },
    clearBranches: (state) => {
      state.branches = [];
    },
  },
  extraReducers: {
    [getBranchList.fulfilled]: (state, action) => {
      const { payload } = action;
      if (Array.isArray(payload)) {
        state.branches = payload;
      } else if (Array.isArray(payload?.data)) {
        state.branches = payload.data;
      } else {
        state.branches = [];
      }
    },
    [validateSnRange.pending]: (state) => {
      state.isValidating = true;
      state.validateResult = null;
    },
    [validateSnRange.fulfilled]: (state, action) => {
      state.isValidating = false;
      state.validateResult = action.payload;
    },
    [validateSnRange.rejected]: (state, action) => {
      state.isValidating = false;
      state.validateResult = {
        success: false,
        message: action.payload || "Validation failed",
      };
    },
    [moveSnToCompany.pending]: (state) => {
      state.isMoving = true;
      state.moveResult = null;
    },
    [moveSnToCompany.fulfilled]: (state, action) => {
      state.isMoving = false;
      state.moveResult = action.payload;
    },
    [moveSnToCompany.rejected]: (state, action) => {
      state.isMoving = false;
      state.moveResult = {
        success: false,
        message: action.payload || "Move failed",
      };
    },
  },
});

export const { clearValidateResult, clearMoveResult, clearBranches } =
  managementSnSlice.actions;
export const managementSnReducer = managementSnSlice.reducer;
